export default "__VITE_ASSET__0d95cbb6__"